import React from 'react'
import { t } from 'ttag'

import { JobPositionModal } from 'components/modals/common/JobPositionModal/JobPositionModal'

import { useJobPositionModal } from 'components/modals/common/JobPositionModal/hooks'

export const PositionTemplateManagementModal = ({
  template,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  isStandalone = true,
}) => {
  const { state, handlers } = useJobPositionModal(
    { template, isOpen, isPositionManagement: false },
    { onCancel, onClose, onConfirm },
  )

  const { activeTab, tab, tabs, isConfirmationOpen, isFirstStep, isLastStep } =
    state
  const {
    handleBack,
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleTab,
  } = handlers

  return (
    <JobPositionModal
      title={template ? t`Edit job template` : t`Create job template`}
      onBack={isStandalone ? (!isFirstStep ? handleBack : null) : handleBack}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmationClose={handleConfirmationClose}
      onConfirmationConfirm={handleConfirmationConfirm}
      onTab={handleTab}
      {...{ activeTab, tab, tabs, isConfirmationOpen, isLastStep, isOpen }}
    />
  )
}
